import { render, staticRenderFns } from "./StudentSurveyManage.vue?vue&type=template&id=ae88582e&scoped=true"
import script from "./StudentSurveyManage.vue?vue&type=script&lang=js"
export * from "./StudentSurveyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae88582e",
  null
  
)

export default component.exports